import { Component } from '@angular/core';

@Component({
  selector: 'app-bulk-asset-link',
  templateUrl: './bulk-asset-link.component.html',
  styleUrls: ['./bulk-asset-link.component.scss']
})
export class BulkAssetLinkComponent {

}
